import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { NotificationsEntity } from '../notifications/notifications.entity';
import { ProfileModule } from '../profile/profile.module';
import { RolesEntity } from '../roles/roles.entity';
import { UserEntity } from '../user/user.entity';
import { VillageModule } from '../village/village.module';
import { ComplaintFilesEntity } from './complaint-files.entity';
import { ComplaintTypeEntity } from './complaint-type.entity';
import { ComplaintController } from './complaint.controller';
import { ComplaintEntity } from './complaint.entity';
import { ComplaintService } from './complaint.service';
import { ComplaintStatusEntity } from './status-details.entity';

@Module({
  imports: [
    TypeOrmModule.forFeature([ComplaintEntity,ComplaintTypeEntity,ComplaintFilesEntity,ComplaintStatusEntity,NotificationsEntity,RolesEntity,UserEntity]),
    ProfileModule,VillageModule
],
  controllers: [ComplaintController],
  providers: [ComplaintService],
  exports:[ComplaintService],
})
export class ComplaintModule {}
